export default function Divider() {
  return (
    <path
      d="M1.5 1C1.5 0.723858 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723858 0.5 1L1.5 1ZM0.5 1L0.499999 27L1.5 27L1.5 1L0.5 1Z"
      fill="#039AF8"
      fillOpacity="0.39"
    />
  );
}
